import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import createRootReducer from './redux/reducers';
import createDebounce from "redux-debounced";
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

export const history = createBrowserHistory()
const middlewares = [thunk, createDebounce()]
export default function configureStore() {
  const composeEnhancer = compose;
  const store = createStore(
      createRootReducer(history),
      composeEnhancer(applyMiddleware(...middlewares)),
  )

  return store
}

const useSelector = useReduxSelector;

const useDispatch = () => useReduxDispatch();

const store = configureStore();

export { store, useSelector, useDispatch  }
